import style from './ExamesGHE.module.css';

import SmallLoading from "../../Utils/SmallLoading";
import FilterContainer from '../../Utils/FilterContainer';

import { GoTrash } from "react-icons/go";

import { useEffect, useState, useRef, useCallback, useContext } from "react";
import { AuthContext } from '../../../Auth/AuthProvider';
import Overlay from '../../Overlay';
import FormContainer from '../../FormContainer';
import FormComp from '../../FormComp';
import { VerifyPermission } from '../../../Funcoes/VerifyPermission'
import useApi from "../../../hooks/useApi";


const ExamesGHE = () => {
    const api = useApi();


    const { user } = useContext( AuthContext )

    const containerRef = useRef(null);

    const [loading, setloading] = useState(false);

    const [linhas, setLinhas] = useState(100);

    const [responseValues, setResponseValues] = useState([]);
    const [responseValuesFilter, setResponseValuesFilter] = useState([]);

    const [obras, setObras] = useState([]);
    const [ghes, setGhes] = useState([]);
    const [asos, setAsos] = useState([]);
    const [exames, setExames] = useState([]);

    const [obrasVal, setObrasVal] = useState([]);
    const [ghesVal, setGhesVal] = useState([]);
    const [asosVal, setAsosVal] = useState([]);
    const [examesVal, setExamesVal] = useState([]);

    const [newExames, setNewExames] = useState(false)

    const handleFilter = useCallback(() => {

        setResponseValuesFilter(
            responseValues.filter((item) => {

                const obraFilter = !obrasVal.length || obrasVal.some(obj => (item.centro_custo || '').includes(obj.value))
                const gheFilter = !ghesVal.length || ghesVal.some(obj => (item.ghe || '').includes(obj.value))
                const asoFilter = !asosVal.length || asosVal.some(obj => (item.aso || '').includes(obj.value))
                const exameFilter = !examesVal.length || examesVal.some(obj => (item.exame || '').includes(obj.value))

                return obraFilter && gheFilter && asoFilter && exameFilter;

            })
        )

    }, [obrasVal, ghesVal, asosVal, examesVal])

    useEffect(() => {

        handleFilter()

    }, [handleFilter])

    const verifyHeight = () => {

        const container = containerRef.current;

        if (container.scrollTop + container.clientHeight >= container.scrollHeight) {

            setLinhas(prev => prev + 100)

        }

    }

    const getValues = async () => {

        setloading(true);

        try {

            const { data } = await api.get('/Painel/API/InfoPanel/GHE_Exames/', { withCredentials: true })
            console.log(data);

            setResponseValues(data);
            setResponseValuesFilter(data);

            setObras([...new Set(data.map(obj => obj.centro_custo).sort())])
            setGhes([...new Set(data.map(obj => obj.ghe).sort())])
            setAsos([...new Set(data.map(obj => obj.aso).sort())])
            setExames([...new Set(data.map(obj => obj.exame).sort())])

        } catch (e) {

            console.error(e);

        } finally {

            setloading(false);

        }

    }

    useEffect(() => {

        getValues();

    }, [])

    const [loadingInfo, setLoadingInfo] = useState(false);

    const [listaCC, setListaCC] = useState([])
    const [listaGHE, setListaGHE] = useState([])
    const [listaExames, setListaExames] = useState([])

    const openNewModal = async () => {

        setLoadingInfo(true)
        setNewExames(true)

        try {

            const [obrasList, GHEList, examesList] = await Promise.all([
                api.get('/Painel/API/GetAllObras/'),
                api.get('/Painel/API/InfoPanel/GHEList/'),
                api.get('/Painel/API/InfoPanel/ExamesList/')
            ])

            console.log(obrasList.data)
            console.log(GHEList.data)
            console.log(examesList.data)

            setListaCC(obrasList.data)
            setListaGHE(GHEList.data)
            setListaExames(examesList.data)

        } catch (e) {

            console.error("Erro ao carregar obras:", e);
            alert("Erro ao carregar informações. Tente novamente.");

        } finally {

            setLoadingInfo(false)

        }

    }

    const [ccVal, setCCVal] = useState("");
    const [gheVal, setGheVal] = useState("");
    const [asoVal, setAsoVal] = useState([]);
    const [exameVal, setExameVal] = useState([]);

    const closeNewModal = () => {

        setCCVal("")
        setGheVal("")
        setAsoVal([])
        setExameVal([])

        setNewExames( false )

    }

    const [ saving, setSaving ] = useState( false )

    const handleSubmit = async ( e ) => {

        e.preventDefault();

        if( !VerifyPermission( user, { modulo: "ssma", submodulo: "painel-ctrl", funcao: "gerar_exame_ghe" })){

            alert("Você não tem permissão para realizar esta ação.");
            return;

        }

        setSaving( true )

        const payload = {
            centro_custo: ccVal,
            ghe: gheVal,
            aso: asoVal.map( a => a.value ),
            exame: exameVal.map( e => e.value )
        };

        try{

            const { data } = await api.post("/Painel/API/InfoPanel/SaveNewExameGhe/", payload, {
                withCredentials: true
            })

            console.log( data );

            await getValues();
            closeNewModal();

        }catch( e ){

            console.error( e )
            alert( "Erro ao salvar informação" )

        }finally{

            setSaving( false )

        }

    }

    const [ deleteItem, setDeleteItem ] = useState( null );
    const [ deleteModal, setDeleteModal ] = useState( false );
    const [ deleteLoading, setDeleteLoading ] = useState( false );

    const OpenDeleteModal = ( itemId ) => {

        setDeleteItem( itemId )
        setDeleteModal( true )

    }

    const cancelDelete = () => {

        setDeleteItem( null )
        setDeleteModal( false )

    }

    const deleteExame = async () => {

        if( !VerifyPermission( user, { modulo: "ssma", submodulo: "painel-ctrl", funcao: "excluir_exame_ghe" }) ){

            alert("Você não tem permissão para realizar esta ação.");
            return;

        }

        setDeleteLoading( true );

        try{

            const { data } = await api.post("/Painel/API/InfoPanel/DeleteExameGhe/",
                { id: deleteItem },
                { withCredentials: true }
            )

            console.log( data )
            await getValues();
            cancelDelete();

        }catch( e ){

            console.error( e )

        }finally{

            setDeleteLoading( false )

        }

    }

    return (
        <>
            {loading
                ? <SmallLoading />
                :
                <>
                    <div className={style.headTitle} >
                        <p className={style.title}>EXAMES x GHE</p>
                        {
                            VerifyPermission( user, { modulo: "ssma", submodulo: "painel-ctrl", funcao: "gerar_exame_ghe" }) &&
                            <button className={style.btnNovo} onClick={() => openNewModal()} > NOVO </button>
                        }
                    </div>
                    <div className={style.containerFilters} >
                        <FilterContainer
                            type="select"
                            placeholder="CENTRO CUSTO..."
                            options={obras}
                            optType="obj"
                            valor={obrasVal}
                            changeFunc={(selected) => setObrasVal(selected)}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="GHE..."
                            options={ghes}
                            optType="obj"
                            valor={ghesVal}
                            changeFunc={(selected) => setGhesVal(selected)}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="ASO..."
                            options={asos}
                            optType="obj"
                            valor={asosVal}
                            changeFunc={(selected) => setAsosVal(selected)}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="EXAME..."
                            options={exames}
                            optType="obj"
                            valor={examesVal}
                            changeFunc={(select) => setExamesVal(select)}
                        />
                    </div>
                    <div className={style.containerTable} ref={containerRef} onScroll={verifyHeight} >
                        <table>
                            <thead>
                                <tr>
                                    <th>CENTRO CUSTO</th>
                                    <th>GHE</th>
                                    <th>ASO</th>
                                    <th>EXAME</th>
                                    <th className={style.delCol} ></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    responseValuesFilter.slice(0, linhas).map((obj, index) => (
                                        <tr key={index} >
                                            <td>{obj.centro_custo}</td>
                                            <td>{obj.ghe}</td>
                                            <td>{obj.aso}</td>
                                            <td>{obj.exame}</td>
                                            <td className={style.delCol} >
                                                <div className={style.delContainer} onClick={() => OpenDeleteModal( obj.id )} >
                                                    <GoTrash className={style.delIcon} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </>
            }
            <Overlay state={newExames} >
                <FormContainer closeFunc={ closeNewModal } loadingContent={loadingInfo} loadingSave={ saving } >
                    <form onSubmit={ handleSubmit } >
                        <FormComp
                            title="CENTRO CUSTO"
                            type="select"
                            name="centro_custo"
                            valor={ ccVal }
                            changeFunc={ e => setCCVal( e.target.value )}
                            options={
                                listaCC?.map(opt => ({
                                    value: opt.OBRA,
                                    label: opt.OBRA
                                })
                                )}
                            obj={true}
                            required
                        />
                        <FormComp
                            title="GHE"
                            type="select"
                            name="ghe"
                            valor={ gheVal }
                            changeFunc={ e => setGheVal( e.target.value )}
                            options={
                                listaGHE?.map(opt => ({
                                    value: opt.id,
                                    label: opt.nome
                                }))
                            }
                            obj={true}
                            required
                        />
                        <FormComp
                            title="TIPO ASO"
                            type="multiselect"
                            placeholder="SELECIONE..."
                            name="tipo_aso"
                            valor={ asoVal }
                            changeFunc={setAsoVal}
                            options={[
                                { value: 0, label: 'ADMISSIONAL' },
                                { value: 1, label: 'PERIÓDICO' },
                                { value: 2, label: 'RETORNO AO TRABALHO' },
                                { value: 3, label: 'MUDANÇA DE FUNÇÃO/RISCO' },
                                { value: 9, label: 'DEMISSIONAL' }
                            ]}
                            required
                        />
                        <FormComp
                            title="EXAME"
                            type="multiselect"
                            placeholder="SELECIONE..."
                            name="exame"
                            valor={ exameVal }
                            changeFunc={setExameVal}
                            options={
                                listaExames.map(opt => ({
                                    value: opt.id,
                                    label: opt.exame
                                }))
                            }
                            required
                        />
                        <FormComp
                            type="submit"
                            valor="SALVAR"
                        />
                    </form>
                </FormContainer>
            </Overlay>
            <Overlay state={ deleteModal } >
                <div className={ style.deleteModal } >
                    <p>Realmente deseja apagar o exame ?</p>
                    <div className={ style.deleteBtnContainer } >
                        <button className={ style.deleteCancel } onClick={ cancelDelete } disabled={ deleteLoading } >CANCELAR</button>
                        <button className={ style.deleteConfirm } onClick={ deleteExame } disabled={ deleteLoading } >
                            {
                                deleteLoading ? "CARREGANDO..." : "APAGAR"
                            }
                        </button>
                    </div>
                </div>
            </Overlay>
        </>
    )

}

export default ExamesGHE;